<template>
  <div class="scene">
    <div class="cube">
      <div class="front" />
      <div class="back" />
      <div class="left" />
      <div class="right" />
      <div class="top" />
      <div class="bottom" />
    </div>
  </div>
</template>

<script lang="js">
export default {
  mounted() {
    const cube = document.querySelector('.cube')
    let rotationX = -30
    let rotationY = 30
    let isRotating = true

    let isMouseDown = false
    let lastX = 0
    let lastY = 0

    function randomRotation() {
      const randomX = Math.floor(Math.random() * 360)
      const randomY = Math.floor(Math.random() * 360)

      function animate() {
        if (isRotating) {
          rotationX += 0.2
          rotationY += 0.2
          cube.style.transform = `rotateX(${randomX + rotationX}deg) rotateY(${randomY + rotationY}deg)`
        }
        if (isRotating) {
          requestAnimationFrame(animate)
        }
      }
      animate()
    }

    cube.addEventListener('mouseenter', () => {
      if (!isMouseDown) {
        isRotating = false
        // cube.style.transition = 'none'
      }
    })

    cube.addEventListener('mouseleave', () => {
      if (!isMouseDown) {
        isRotating = true
        cube.style.transition = 'transform 1s'
        randomRotation()
      }
    })

    cube.addEventListener('mousedown', (e) => {
      isMouseDown = true
      lastX = e.clientX
      lastY = e.clientY
      cube.style.transition = 'none'
    })

    document.addEventListener('mousemove', (e) => {
      if (!isMouseDown) return

      const deltaX = e.clientX - lastX
      const deltaY = e.clientY - lastY

      rotationX -= deltaY * 0.1
      rotationY += deltaX * 0.1

      cube.style.transform = `rotateX(${rotationX}deg) rotateY(${rotationY}deg)`

      lastX = e.clientX
      lastY = e.clientY
    })

    document.addEventListener('mouseup', () => {
      isMouseDown = false
      isRotating = true
      cube.style.transition = 'transform 1s'
      randomRotation()
    })

    randomRotation()
  },
}
</script>

<style lang="scss" scoped>
.scene {
  perspective: 800px; /* 设置视角 */
  position: absolute;
  right: 100px;
  bottom: 200px;
}

.cube {
  width: 160px; /* 缩小20% */
  height: 160px; /* 缩小20% */
  transform-style: preserve-3d;
  transform: rotateX(-30deg) rotateY(30deg);
  position: relative;
  will-change: transform; /* 优化性能 */
}

.cube div {
  position: absolute;
  width: 160px; /* 缩小20% */
  height: 160px; /* 缩小20% */
  // background-color: rgba(0, 128, 255, 0.7);
  border: 1px solid #ccc;
}

.front {
  transform: translateZ(80px);
  background:url('@/assets/image/cube/1.png') no-repeat;
  background-size: 100% 100%;
}
.back {
  transform: rotateY(180deg) translateZ(80px);
  background:url('@/assets/image/cube/2.png') no-repeat;
  background-size: 100% 100%;
}
.left {
  transform: rotateY(-90deg) translateZ(80px);
  background:url('@/assets/image/cube/3.png') no-repeat;
  background-size: 100% 100%;
}
.right {
  transform: rotateY(90deg) translateZ(80px);
  background:url('@/assets/image/cube/4.png') no-repeat;
  background-size: 100% 100%;
}
.top {
  transform: rotateX(90deg) translateZ(80px);
  background:url('@/assets/image/cube/5.png') no-repeat;
  background-size: 100% 100%;
}
.bottom {
  transform: rotateX(-90deg) translateZ(80px);
  background:url('@/assets/image/cube/6.png') no-repeat;
  background-size: 100% 100%;
}

@media (max-width: 768px) {
  .scene {
    perspective: 600px;
    position: absolute;
    right: 45px;
    bottom: 80px;
  }

  .cube {
    width: 100px;
    height: 100px;
  }

  .cube div {
    width: 100px;
    height: 100px;
  }

  .front {
  transform: translateZ(50px);
  background:url('@/assets/image/cube/1.png') no-repeat;
  background-size: 100% 100%;
}
.back {
  transform: rotateY(180deg) translateZ(50px);
  background:url('@/assets/image/cube/2.png') no-repeat;
  background-size: 100% 100%;
}
.left {
  transform: rotateY(-90deg) translateZ(50px);
  background:url('@/assets/image/cube/3.png') no-repeat;
  background-size: 100% 100%;
}
.right {
  transform: rotateY(90deg) translateZ(50px);
  background:url('@/assets/image/cube/4.png') no-repeat;
  background-size: 100% 100%;
}
.top {
  transform: rotateX(90deg) translateZ(50px);
  background:url('@/assets/image/cube/5.png') no-repeat;
  background-size: 100% 100%;
}
.bottom {
  transform: rotateX(-90deg) translateZ(50px);
  background:url('@/assets/image/cube/6.png') no-repeat;
  background-size: 100% 100%;
}
}
</style>
